import React from 'react';
import { Typography, Divider } from 'antd';
import './PrivacyPolicy.css';

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy: React.FC = () => {
  React.useEffect(() => {
    document.title = 'Informativa privacy | Miglioriamo CRM';
  }, []);

  return (
    <div className="privacy-policy">
      <header className="privacy-policy__header">
        <Title level={1} className="privacy-policy__title">
          PRIVACY POLICY
        </Title>
        <Paragraph className="privacy-policy__meta">Art. 13 Reg. UE 2016/679</Paragraph>
      </header>

      <section className="privacy-policy__section">
        <Paragraph>
          Ai sensi dell’articolo 13 del Regolamento Europeo 2016/679 (da ora in poi “GDPR”), Miglioriamo s.n.c. in
          qualità di Titolare, è tenuta a fornire agli utenti che si collegano al dominio: landing.miglioriamo.com
          (indipendentemente dagli scopi del collegamento) alcune informazioni relative al trattamento dei dati
          personali ivi effettuato.
        </Paragraph>
        <Paragraph>
          Il presente documento costituisce la “Privacy Policy” (soggetta in futuro ad ogni opportuno aggiornamento) di
          questo sito.
        </Paragraph>
        <Paragraph>
          Ai fini della presente informativa, ferme le definizioni di cui all’art. 4 del GDPR si intende per:
        </Paragraph>
        <ul>
          <li>–La Società: Miglioriamo s.n.c., che è Titolare del Trattamento</li>
          <li>
            -Dominio landing.miglioriamo.com: il dominio , raggiungibile attraverso il servizio world wide web della
            rete internet, all’indirizzo landing.miglioriamo.com costituito dai dati, dalle applicazioni, dalle risorse
            tecnologiche, dalle risorse umane, dalle regole organizzative e dalle procedure deputate alla acquisizione,
            memorizzazione, elaborazione, scambio, ritrovamento e trasmissione delle informazioni.
          </li>
          <li>
            -Punti di raccolta: aree presenti all’interno del dominio landing.miglioriamo.com destinate alla raccolta di
            dati personali.
          </li>
        </ul>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>I. Norme di riferimento e basi giuridiche del trattamento</Title>
        <Paragraph>
          Le operazioni di trattamento, che di seguito illustreremo nel dettaglio, hanno il loro fondamento giuridico
          nelle norme che disciplinano il diritto alla protezione dei dati personali, il diritto alla riservatezza, ed
          infine in quelle che permettono di esprimere o di revocare, in qualsiasi momento, il consenso informato alle
          operazioni di trattamento vale a dire:
        </Paragraph>
        <ul>
          <li>
            Il Regolamento Generale UE 679 del 27 Aprile 2016 relativo alla protezione delle persone fisiche con
            riguardo al trattamento dei dati personali, nonché alla libera circolazione di tali dati;
          </li>
          <li>
            Il consenso informato, manifestato in conformità con le vigenti disposizioni di legge in materia di
            protezione dei dati personali (Art. 6 GDPR).
          </li>
          <li>
            L’adempimento degli obblighi contrattuali assunti da Miglioriamo in favore del fruitore al momento
            dell’adesione al Servizio (Art. 6 GDPR);
          </li>
          <li>
            Adempimento di obblighi od ordini cui il Titolare del Trattamento è tenuto in forza di legge o d’ordine
            dell’Autorità (Art. 6 GDPR).
          </li>
        </ul>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>II. Natura dei dati oggetto di trattamento</Title>
        <Paragraph>
          II.1. – L’invio di posta elettronica agli indirizzi indicati su questo sito comporta la successiva acquisizione
          dell’indirizzo del mittente, necessario per rispondere alle richieste, nonché degli eventuali altri dati
          personali inseriti nella missiva. Specifiche informative di sintesi verranno progressivamente riportate o
          visualizzate nelle pagine del sito predisposte per particolari servizi a richiesta. In ogni caso – ove dalla
          legge previsto – ti sarà richiesto di volta in volta il consenso al trattamento dei tuoi dati personali.
        </Paragraph>
        <Paragraph>
          II.2. – Previo consenso, ove necessario, saranno o potranno essere oggetto di trattamento, per le finalità
          indicate, le seguenti categorie di dati personali che riguardano colui il quale esprime il consenso
          (Interessato):
        </Paragraph>
        <ul>
          <li>
            (a) Dati personali comuni, dati identificativi, come ad es. Nome e Cognome, Anno di nascita, Sesso,
            Indirizzo, Città, Provincia, Indirizzo di posta elettronica, Numero telefonico, C.A.P., Link ai profili dei
            seguenti social network: Facebook, Instagram e Twitter.
          </li>
          <li>
            (b) Trattamenti tecnici Costituiscono altresì oggetto di trattamento il numero IP e il tipo di browser
            utilizzato per la connessione al dominio landing.miglioriamo.com (dati non identificativi), registrati
            automaticamente dai dispositivi logici di protezione e di controllo degli accessi al dominio (LOG FILES).
            Tali dati personali saranno utilizzati esclusivamente a fini di controllo del traffico di rete verso il
            dominio. Si tratta di informazioni che non sono raccolte per essere associate a Interessati identificati, ma
            che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi,
            permettere di identificare gli utenti. Questi dati vengono utilizzati al solo fine di ricavare informazioni
            statistiche anonime sull’uso del sito e per controllarne il corretto funzionamento e vengono cancellati
            immediatamente dopo l’elaborazione. I dati potrebbero essere utilizzati per l’accertamento di
            responsabilità in caso di ipotetici reati informatici ai danni del sito: salva questa eventualità, allo
            stato, i dati sui contatti web non persistono per più di sette giorni.
          </li>
          <li>
            (c) Cookies Per informazioni più dettagliate sull’utilizzo dei cookies sul sito landing.miglioriamo.com è
            possibile consultare la Cookies Policy.
          </li>
          <li>
            (d) Categorie particolari di dati personali Nel caso in cui attraverso il dominio landing.miglioriamo.com
            sia effettuata la raccolta di categorie particolari di dati personali ex art. 9 Reg. UE 679/2016, l’utente
            sarà preventivamente informato e messo in condizione di esprimere – nei modi di legge – il relativo consenso.
          </li>
        </ul>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>III. Natura del conferimento, fonti dei dati</Title>
        <Paragraph>
          Il conferimento dei dati personali non è di regola obbligatorio ma, in alcuni casi, risulta necessario, e
          quindi obbligatorio, per consentire di beneficiare dei servizi e delle funzionalità proprie del sito.
        </Paragraph>
        <Paragraph>
          III.1. Dati il cui conferimento è necessario
        </Paragraph>
        <ul>
          <li>
            III.1.1. Il conferimento di taluni dati personali è necessario, e quindi obbligatorio, per dare corso alle
            specifiche richieste; l’utente è sempre libero di non fornire i suoi dati personali, ma in tal caso potrebbe
            essere impossibile per il Titolare del trattamento soddisfare le richieste, fare fronte alle esigenze o far
            utilizzare, nella loro interezza, tutte le funzioni disponibili sul sito .
          </li>
          <li>
            III.1.2. Il conferimento di dati personali identificativi è necessario per potersi eventualmente registrare
            al sito e ricevere, insieme agli altri vantaggi, le informazioni desiderate sui servizi di marketing.
          </li>
          <li>
            III.1.3. Tali dati identificativi saranno trattati sia con supporti cartacei che elettronici, e saranno
            conservati da Miglioriamo s.n.c. esclusivamente fintantoché gli interessati manterranno la loro iscrizione
            al sito, o comunque per un tempo massimo di 5 anni dall’ultima azione svolta all’interno del sito stesso. Al
            termine del tempo di conservazione, i dati personali identificativi saranno cancellati automaticamente.
          </li>
        </ul>
        <Paragraph>III.2. Fonti dei Dati</Paragraph>
        <Paragraph>Raccoglieremo i dati dall’utente direttamente, attraverso le interazioni con il sito.</Paragraph>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>IV. Finalità del Trattamento</Title>
        <Paragraph>
          La Società oltre ai trattamenti necessari in relazione ad obblighi di legge, di Regolamento, o derivanti da
          ordine dell’Autorità, effettuerà, esclusivamente con il consenso, eventualmente necessario, dell’utente, le
          operazioni necessarie per consentire di beneficiare dei servizi e delle funzionalità del sito e, nello
          specifico:
        </Paragraph>
        <ul>
          <li>1. la gestione del rapporto contrattuale;</li>
          <li>
            2. finalità strettamente connesse e strumentali alla gestione del suddetto rapporto (ad es. per
            l’acquisizione di informazioni precontrattuali e per dare esecuzione ai servizi ed operazioni, come
            contrattualmente convenute);
          </li>
          <li>
            3. finalità afferenti al controllo dell’andamento delle relazioni con la clientela e dei controlli dei
            rischi di credito e frodi connessi ai servizi prestati;
          </li>
          <li>4. adempiere a specifiche richieste dell’interessato.</li>
        </ul>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>V. Modalità di trattamento dei suoi dati personali</Title>
        <Paragraph>
          In relazione a tutte le finalità indicate nei paragrafi precedenti, i dati personali saranno oggetto di
          trattamento informatico e/o cartaceo ed elaborati con tecniche di pseudonimizzazione ed anonimizzazione al
          fine della personalizzazione dei servizi che la Società è in grado di offrire. Il trattamento dei dati avverrà
          in modo da garantirne la sicurezza logica e fisica e la riservatezza, e potrà essere effettuato attraverso
          strumenti manuali, informatici e telematici atti a memorizzare, trasmettere e condividere i dati stessi. Le
          logiche del trattamento saranno strettamente correlate alle finalità perseguite.
        </Paragraph>
        <Paragraph>
          V.1. Sicurezza e conservazione dei dati V.1.1. I dati personali saranno conservati all’interno dell’Unione
          Europea, le relative politiche di sicurezza sono revisionate in conformità con le Best Practices in materia.
        </Paragraph>
        <Paragraph>
          V.1.2. Tracciabilità degli Accessi e delle operazioni. Audit Log Ogni accesso ai dati verrà memorizzato in
          apposite tabelle di Log. Le relative informazioni conterranno il timestamp dell’accesso, l’identificativo
          dell’utente che ha acceduto ai dati; la tipologia dei dati cui è stato fatto l’accesso, l’utente proprietario
          dei dati, l’operazione effettuata, l’applicazione da cui è stato effettuato l’accesso.
        </Paragraph>
        <Paragraph>
          V.1.3. Profilazione, processo decisionale automatizzato Non effettuiamo, ad eccezione di quanto precisato
          nella nostra cookie policy, operazioni di profilazione, in relazione ai dati raccolti attraverso questo sito
          internet, ulteriori rispetto a quanto necessario per consentirci di eseguire le prestazioni che consentono di
          fruire dei servizi offerti sul sito stesso.
        </Paragraph>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>VI. Destinatari dei dati e trasferimenti all’estero</Title>
        <Paragraph>
          VI.1. Responsabili e incaricati del trattamento di dati Possono venire a conoscenza dei dati personali, di cui
          alla presente informativa, in qualità di Responsabili e/o Incaricati del trattamento:
        </Paragraph>
        <ul>
          <li>
            il personale qualificato della Società, limitatamente alle relative competenze e/o mansioni e sulla base dei
            compiti assegnati e delle istruzioni impartite;
          </li>
          <li>
            soggetti terzi esterni alla Società, appositamente designati quali Responsabili e/o incaricati del
            trattamento, dei quali la Società si avvale per l’espletamento di specifici servizi, limitatamente alle
            relative competenze e/o mansioni e sulla base dei compiti assegnati e delle istruzioni impartite.
          </li>
        </ul>
        <Paragraph>
          VI.2. Comunicazione (a soggetti esterni determinati) dei dati La Società, per le ordinarie attività
          gestionali, contabili e amministrative, potrà comunicare i dati personali, previa eventuale acquisizione del
          consenso nei modi di legge, nel rispetto delle misure di sicurezza, a terzi fornitori di servizi al solo fine
          di eseguire la prestazione richiesta, quali: società di servizi postali, studi legali e notarili, consulenti,
          anche in forma associata, altre società di servizio, nonché ad ulteriori soggetti in ottemperanza a eventuali
          obblighi di legge (quali istituti di assicurazione, forze di polizia, autorità giudiziaria, ecc.). L’elenco di
          tali soggetti cui i dati potranno essere comunicati è disponibile presso la sede del Titolare del trattamento.
        </Paragraph>
        <Paragraph>
          VI.3. Trasferimento di dati personali all’estero La Società non trasferisce di propria iniziativa dati
          personali extra UE. Tuttavia alcuni soggetti terzi, fornitori di servizi, potrebbero avere i propri server
          collocati fisicamente nei territori al di fuori dell’Unione (come nel caso di provider di posta elettronica).
          In tali eventualità, il trasferimento di dati all’estero avverrà esclusivamente nell’ambito e nel rispetto del
          Reg. UE 679/2016 Art. 44 ss.
        </Paragraph>
        <Paragraph>VI.4. Diffusione (a soggetti esterni indeterminati) dei dati In nessun caso i dati personali potranno essere diffusi.</Paragraph>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>VII. – Diritti dell’interessato</Title>
        <Paragraph>
          Gli articoli 15-22 GDPR conferiscono agli interessati l’esercizio di specifici diritti. L’art. 15 GDPR
          riconosce agli interessati il diritto di accedere ai propri dati personali e di ottenerne copia. Il diritto di
          ottenere copia dei dati non deve ledere i diritti e le libertà altrui.
        </Paragraph>
        <Paragraph>
          Con la domanda d’accesso, l’interessato ha diritto di ottenere dal Titolare la conferma o meno se sia in corso
          un trattamento sui propri dati personali e di conoscere le finalità e le categorie di dati trattate, i
          soggetti terzi cui i dati sono comunicati e se i dati sono trasferiti in un paese extracomunitario con
          garanzie adeguate. L’Interessato ha, altresì, diritto di conoscere il tempo di conservazione dei propri dati
          personali ed ha il diritto di chiedere la rettifica dei dati inesatti e la integrazione di quelli incompleti,
          la cancellazione (diritto all’oblio) alle condizioni indicate dall’art. 17, GDPR, la limitazione del
          trattamento, la revoca del consenso, la portabilità dei dati e il diritto di opporsi, in qualsiasi momento e
          senza dover fornire delle giustificazioni, al trattamento per finalità di marketing diretto.
        </Paragraph>
        <Paragraph>
          L’interessato che ritenga che il trattamento dei propri dati personali violi le disposizioni del GDPR o della
          normativa interna in materia di protezione dei dati personali ha diritto di proporre reclamo all’Autorità
          Garante per la Protezione dei Dati Personali con sede in Roma, ai sensi dell’art. 77 GDPR e/o di adire
          l’Autorità giudiziaria.
        </Paragraph>
        <Paragraph>
          I diritti potranno essere esercitati mediante richiesta da partecipare all’indirizzo e-mail{' '}
          <a href="mailto:daiscrivici@miglioriamo.net">daiscrivici@miglioriamo.net</a>, oppure mediante raccomandata a/r
          all’indirizzo <a href="mailto:miglioriamo@pec.it">miglioriamo@pec.it</a>, Via E. Fermi n.ro 1 – Perugia (PG) .
          Il Titolare e/o il suo eventuale DPO potrebbero avere bisogno di identificare l’interessato mediante richiesta
          di fornire copia del proprio documento d’identità.
        </Paragraph>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>VIII. Revoca Del Consenso – Domande Sulla Privacy – Accesso e Riscontro</Title>
        <Paragraph>
          È riconosciuta in ogni momento all’Interessato la facoltà di revocare il consenso al trattamento dei dati
          personali comunicandoci l’intenzione a mezzo mail all’indirizzo{' '}
          <a href="mailto:daiscrivici@miglioriamo.net">daiscrivici@miglioriamo.net</a>, oppure mediante raccomandata a/r
          all’indirizzo <a href="mailto:miglioriamo@pec.it">miglioriamo@pec.it</a>, Via E. Fermi n.ro 1 – Perugia (PG) .
          Con le stesse modalità potranno essere richieste informazioni in ordine al trattamento dei propri dati
          personali. Prima che la Società possa fornire o modificare qualsiasi informazione, potrebbe essere necessario
          verificare la sua identità e rispondere ad alcune domande. Una nostra risposta sarà fornita al più presto.
        </Paragraph>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>IX. Titolare del Trattamento</Title>
        <Paragraph>
          Titolare del trattamento è Miglioriamo S.N.C. con sede a Perugia in Via E. Fermi n.ro 1 (PG)
        </Paragraph>
      </section>

      <section className="privacy-policy__section">
        <Title level={3}>X.1. Responsabili del trattamento</Title>
        <Paragraph>
          L’elenco completo dei Responsabili del trattamento è disponibile presso la sede della Società. Le presenti
          informazioni obbligatorie sono soggette ad aggiornamento, in dipendenza di eventuali mutamenti delle
          disposizioni di legge applicabili.
        </Paragraph>
      </section>

      <Divider />

      <footer className="privacy-policy__footer">
        <Text type="secondary">
          Versione aggiornata al {new Date().toLocaleDateString('it-IT')}.
        </Text>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
